// src/components/Q8Button.js
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

const Q8Button = ({
  icon,
  label,
  size = 'medium',
  variant = 'primary',
  disabled = false,
  onClick,
  sx,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      disabled={disabled}
      onClick={onClick}
      startIcon={icon}
      sx={sx}
      {...props}
    >
      {label}
    </Button>
  );
};

Q8Button.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  sx: PropTypes.object,
};

Q8Button.defaultProps = {
  size: 'medium',
  variant: 'primary',
  disabled: false,
};

export default Q8Button;